import clsx from 'clsx';
import React from 'react';
import { isArray } from './is.js';
import { jsx } from 'react/jsx-runtime';

function getHighlightText({
  nodeList,
  pattern,
  highlightClassName
}) {
  if (!pattern) {
    return nodeList;
  }
  const transformNode = node => {
    if (node && node.props && typeof node.props.children === 'string') {
      const {
        children
      } = node.props;
      return /*#__PURE__*/React.cloneElement(node, {
        children: (() => {
          let indexOfNextRegTest = 0;
          const result = [];
          children.replace(pattern, (...args) => {
            const match = args[0];
            const index = args[args.length - 2];
            if (index > indexOfNextRegTest) {
              result.push(children.slice(indexOfNextRegTest, index));
            }
            result.push( /*#__PURE__*/jsx("span", {
              className: clsx(highlightClassName),
              children: match
            }, index));
            indexOfNextRegTest = index + match.length;
          });
          result.push(children.slice(indexOfNextRegTest));
          return result;
        })()
      });
    }
    return node;
  };
  return isArray(nodeList) ? nodeList.map(node => transformNode(node)) : transformNode(nodeList);
}

export { getHighlightText as default };
